enum EventWebPageButtonType {
  VentlaInviteLink = 0,
  ExternalLink = 1,
  NoAction = 2,
}
export default Object.freeze(EventWebPageButtonType);
